function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSliderRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 22c1.1 0 2 .9 2 2h5v2h-5c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2H3v-2h15c0-1.1.9-2 2-2h2zm-2 4h2v-2h-2v2zm-9-13c1.1 0 2 .9 2 2h16v2H13c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2H3v-2h4c0-1.1.9-2 2-2h2zm-2 4h2v-2H9v2zM22 4c1.1 0 2 .9 2 2h5v2h-5c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2H3V6h15c0-1.1.9-2 2-2h2zm-2 4h2V6h-2v2z",
    fill: props.color
  }));
}

export default SvgIconSliderRexOutline;